import type { SVGProps } from 'react';
const SvgStarSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
    <path d="M13.781 4.474a.878.878 0 0 0-1.556 0L9.55 9.686l-5.813.918a.87.87 0 0 0-.483 1.471l4.158 4.14-.916 5.78a.87.87 0 0 0 .35.839c.265.191.614.22.908.072l5.25-2.653 5.245 2.653c.29.148.643.12.909-.072a.87.87 0 0 0 .349-.84l-.92-5.78 4.159-4.138a.868.868 0 0 0-.483-1.471l-5.81-.919z" />
  </svg>
);
export default SvgStarSolid;
